import { get } from 'lodash'
import RestClient from './rest-client'

export default class Transaction extends RestClient {
  static get url () {
    return this.apiUrl + '/transactions'
  }
  
  static get paramKey () {
    return 'transaction'
  }

  static async find (filter) {
    const { data } = await this._get(this.url + '/all', filter)

    if (!data.data) {
      const collection = new Array()
      collection.pagination = get(data, 'meta.pagination') || {}
      return collection
    }

    if (Array.isArray(data.data)) {
      const collection = new Array(...data.data.map(o => new this(o)))
      collection.pagination = get(data, 'meta.pagination')
      return collection
    } else {
      return new this(data.data)
    }
  }

  static async export (params) {
    const { data } = await this.http({
      url: this.url + '/export',
      method: 'POST',
      responseType: 'blob',
      params,
      headers: this.headers
    })
    return data
  }
}
